<template>
	<div class="spinfo-view">
		<div class="box">
			<div class="content">
				<div class="content-top">
					<Split class="content-split" v-model="split1">
						<div slot="left" style="background:#fff;height:100%;">
							<div class="tree-wrap">
							
								<infoTree v-bind:infoNum="infoNum" v-bind:chr="chr" @on-refresh="fnInfoListRefresh" :data="goodslist" @on-select="fnTreeSelectAct"></infoTree>
							</div>
						</div>
						<div slot="right" style="background:#fff;height:100%;">
							<div class="list-wrap" ref="tablecontent" style="height:90%">
							
								<div style="height:100%">
								<vxe-table border ref="xTable" height="100%" resizable
									highlight-hover-row highlight-current-row highlight-hover-column highlight-current-column
									:header-cell-style="{background:'#d5d4d4',color:'#000',borderRight:'1px solid #ccc',fontSize:'14px'}"
									:cell-style="{fontSize:'12px'}" :loading="loading" size="mini" align="center" 
									:data="tableData" :row-style='rowStyle'>
									<vxe-table-column type="index" width="50" title="序号"></vxe-table-column>
									<vxe-table-column  width="150px" title="操作">
										<template v-slot="{ row }">
											<div style="display: flex;">
												<li style="padding: 0 10px;">
													<infoAdd @on-confirm="fnInfoListRefresh" :info="row" v-if="xgBtnFlag">
														<div slot="title">
															<vxe-button type="text">编辑</vxe-button>
														</div>
													</infoAdd>
                                                    <div slot="title" v-else @click="btnAuth">
                                                        <vxe-button type="text">编辑</vxe-button>
                                                    </div>
												</li>
												<li>
													<vxe-button v-if="scBtnFlag" @click="fnDeleteInfo(row)" type="text">删除</vxe-button>
													<vxe-button v-else @click="btnAuth" type="text">删除</vxe-button>
												</li>
											
											</div>
										</template>
									</vxe-table-column>
									<vxe-table-column field="Remark" title="摘要" min-width="170"></vxe-table-column>
									
								</vxe-table>
								</div>
								<div style="height:50px">
								<vxe-pager :current-page="tablePage.pageNum" :page-size="tablePage.pageSize"
									:total="tablePage.totalResult" :page-sizes="page_sizes"
									:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
									@page-change="handlePageChange">
								</vxe-pager>
								</div>
							</div>
						</div>
					</Split>
				</div>
			</div>
		</div>
	
	</div>
</template>

<script>
	import infoTree from '../../components/zysort-tree'
	import infoAdd from '../../components/TheAddRemark.vue'
	import { mapState, mapActions } from "vuex";
	export default{
		components:{
			infoTree,
			infoAdd,//修改商品
		},
		data(){
			return{
				excelshow:false,
				exceldata:[],
				isShow:false,
				selectid:'',
				tableData:[],
				tablePage: {
					pageNum: 1,
					pageSize: 50,
					totalResult: 0
				},
				page_sizes: [50, 100, 150, 200, 300, 500],
				loading:false,
				modelshow:false,
				split1:0.15,
				data1:'',
				data2:'',
				tableheight:'',
				goodslist:[],
				infoNum:0,
				chr: false,
				searchCondition:{
					ROOT:'',
					
				},
				DYokdata:false,
				
                newtext:'',
                
				zjBtnFlag: false,//增加
				xgBtnFlag: false,//修改
				cxBtnFlag: false,//搜索
				dyBtnFlag: false,//打印
                scBtnFlag: false,//删除
				infolistp:{
					
					Remark:'',//	 必输项
					
				}
			}
		},
		mounted () {

		//	this.tableheight = this.$refs.tablecontent.offsetHeight-this.$refs.buttonwrap.offsetHeight
			this.isShow = this.$router.history.current.params.values?true:false;

            this.fnWatchWindow()
            
			let type = true;
            this.fnGetinfoByRoot(type);
            
            // 获取用户权限
            let fliterAuthlist = []
            let AuthUserList = this.$fun.Getlocal('AuthUserList')
            eval(AuthUserList).forEach((item)=>{
                item.Subdirectories.forEach((newitem)=>{
                    if(newitem.Id == "P0112"){
                        fliterAuthlist.push(newitem)
                    }	
                })
                fliterAuthlist.forEach((item)=>{
                    this.zjBtnFlag = item.zj
                    this.cxBtnFlag = item.cx
                    this.xgBtnFlag = item.xg
                    this.scBtnFlag = item.sc
                    this.dyBtnFlag = item.dy
                })
            })
		},
		methods:{
			
			rowStyle({ row, rowIndex })
			 {
				
				if (rowIndex%2==1) {
					return {
						backgroundColor: '#f2f2f2'
					}
				}
			 
				if (rowIndex%2==0) {
					return {
						backgroundColor: '#ffffff'
					}
				}
			},
			btnAuth(){
				this.$Message.error('您没有此权限,看看别的叭~')
			},

			fnTreeSelectAct(data){
				this.selectid = data.CategoryID
				this.fnGetinfoByRoot()
				if(!data.children){
					this.chr = true;
				}else{
					this.chr = false;
				}
			},
			fnWatchWindow(){
				const that = this
				window.onresize = () => {//监听浏览器变化
					return (() => {
						that.tableheight = that.$refs.tablecontent.offsetHeight - this.$refs.buttonwrap.offsetHeight
					})()
				}
			},

			fnGetinfoByRoot(type){
				this.loading = true
				let params = this.$fun.GetUserConstant()
				console.log(params)
                    params.PageNo=this.tablePage.pageNum
                    params.PageSize=this.tablePage.pageSize
                    
                    params.Root=this.selectid
				if (type) {
					params.Root = "001"
				}
				return new Promise(resolve=>{
					setTimeout(()=>{
						this.$Api.ErpGetRemarkByRoot(params).then((res)=>{
							console.log(res)
							
							this.tableData=res.data;
							this.loading=false;
							resolve()
						})
					},1)
				})
			},

			fnDeleteInfo(row){
				this.$Modal.confirm({
					title:'确定删除此信息吗？',
					content:'摘要:'+row.Remark,
					onOk:()=>{
						let params=this.$fun.GetUserConstant()
						    params.ID=row.ID
						this.$Api.ErpDelRemark(params).then((res)=>{
							if(res.status=='SUCCESS'){
								this.$Message.success('删除成功！')
								this.fnGetinfoByRoot()
							}else{
								this.$Message.success(res.msg)
							}
						})
					}
				})
			},

			fnUpdateInfoAct(data){
				let userinfo=this.$fun.GetUserConstant()
				let params=Object.assign({},userinfo,data)
				this.$Api.ErpUpdateSPInfo(params).then((res)=>{
					console.log(res)
				})
            },
            
			fnInfoListRefresh(){
				this.fnGetinfoByRoot()
				this.previouspage()
            },
            
            previouspage(){
            	if(this.$router.history.current.params.values){
            		this.$router.replace({name:'SPInfo'})
            	}
            },
            
			showmodel(){
				this.modelshow=!this.modelshow
			},
		
		
		handlePageChange ({ currentPage, pageSize }) {
			this.tablePage.currentPage = currentPage
			this.tablePage.pageSize = pageSize
			this.fnGetinfoByRoot()
		},
		

	
		}
	}
</script>

<style lang="less" scoped>
	@top_height:60px;
	@bottom_height:50px;
	#trre-op{
		font-size:18px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color:rgba(51,51,51,1);
	}
	.title>p{
		padding: 3px 20px;
		font-size: 18px;
		font-family:Microsoft YaHei;
		font-weight:400;
		color:rgba(51,51,51,1);
		overflow: hidden;
		font-weight: 600;
		text-align: center;
	}
	.title>p>span{
		width:38px;
		height:7px;
		background:rgba(34,116,200,1);
		display: block;
	}
	.spinfo-view{
		width: 100%;
		height:100%;
		margin: 5px;


		.demodialog{
   width: 100%;
    height: 100%;   
    background: rgba(119, 116, 116, 0.651);
  
  
}
	//	align-items: center;
		.box{
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			position: relative;
			background: rgba(244, 244, 244, 0.5);
			.top{
				width: 100%;
				height: 60px;
				//background: #006680;
				display: flex;
				align-items: center;
				border-bottom: 2px solid #ccc;
				.top-left{
					display: flex;
					.wrap{
						display: flex;
						.act-item{
							width: 80px;
							height: 35px;
							background: green;
							display: flex;
							justify-content: center;
							align-items: center;
							font-size: 14px;
							color: #fff;
							margin: 10px;
							border-radius: 3px;
							cursor: pointer;
						}
					}
				}
				.top-right{
					display: flex;
					flex: 1;
					.rightwrap{
						flex: 1;
						display: flex;
						align-items: center;
						justify-content: center;
						//background: #006680;
					}
				}
			}
		
			.content{
				width: 100%;
				height:100%;
				display: flex;
				align-items: center;
				flex-direction: column;
				.content-top{
					width: 100%;
					height: 100%;
					border-bottom: 3px solid #e5faff;
					display: flex;
				.content-split{
					width: 100%;
					height: 100%;
					.tree-wrap{
						width: 100%;
						height: 100%;
						overflow: auto;
						padding: 3px 20px;
						background: #fff;
					}
					.list-wrap{
						height:100%;
						.btnwrap{
							width: 100%;
							display: flex;
							justify-content: flex-end;
							
							.buttons{
								flex: 1;
								height: 35px;
								display: flex;
								padding: 0 20px;
								justify-content: flex-end;
							}
						}
					}
				}
				}
				.content-bottom{
					height: @bottom_height;
					width: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
				}
			}
		}
	}
</style>
<style scoped>
	.vxe-table .vxe-cell{
		padding:0;
		height: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.vxe-body--row{
		font-size: 12px;
	}
	
/deep/	.vxe-table--render-default.size--mini .vxe-body--column.col--ellipsis, .vxe-table--render-default.size--mini .vxe-footer--column.col--ellipsis, .vxe-table--render-default.size--mini .vxe-header--column.col--ellipsis, .vxe-table--render-default.vxe-editable.size--mini .vxe-body--column {
		height:20px;
	}
/deep/	.vxe-table--render-default .vxe-body--column, .vxe-table--render-default .vxe-footer--column, .vxe-table--render-default .vxe-header--column
	{
		line-height:20px;
	}
</style>